import { useTranslation } from 'react-i18next';

import { ErrorView } from 'shared/components/ErrorView';

export const AuthenticatingError = () => {
    const { t } = useTranslation();
    return <ErrorView title={t('loginFailed')} message={t('failureDuringAuthentication')} />;
};
